import React, { Component } from 'react';
import './PendingAccreditationsList.css';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { Redirect } from "react-router-dom";
import _ from 'lodash';
import { sharedLabelsPath } from "../../../reducers/common/localization";
import moment from 'moment';
import IconContainer from "../../commonComponents/iconContainer/IconContainer";
import {Utils} from "../../../utils/utils";

class PendingAccreditationsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentAccreditationId: null
        };
    }

    componentDidMount() {
        this.props.onGetAccreditations();
    }

    render() {
        return (
            <div className='pending-accreditations-list-container'>
                <h4 className="page-label">{_.get(this.props.translation, "applicant_accreditations_management.pending_accreditations_label")}</h4>
                {this.renderContent()}
            </div>
        );
    }

    renderContent = () => {
        if (this.props.loading && (_.isNil(this.props.data) || this.props.data.length === 0)) {
            return (
                <div className="pending-accreditations-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }       
        
        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="pending-accreditations-status-message-container">
                    <h6>
                        {Utils.getTagsFromStringWithStyles(_.get(this.props.translation,
                            'applicant_accreditations_management.no_pending_accreditations_label'))}
                    </h6>
                </div>
            );
        }
        
        if (!_.isNil(this.state.currentAccreditationId)) {
            return <Redirect to={"/validate-pending-accreditation?id=" + this.state.currentAccreditationId} push />;
        }

        return (
            <Table className='pending-accreditations-list-table' cellSpacing="0">
                <thead>
                    <tr>
                        <th>{_.get(this.props.translation, 'accreditation.accreditation_title_orig_label')}</th>
                        <th>{_.get(this.props.translation, 'accreditation.accreditation_title_en_label')}</th>
                        <th>{_.get(this.props.translation, 'accreditation.date_issued_label')}</th>
                        <th>{_.get(this.props.translation, 'applicant_accreditations_management.issued_by_label')}</th>
                        <th>{_.get(this.props.translation, 'accreditation.level_label')}</th>
                        <th/>
                    </tr>
                </thead>
                <tbody>
                    {this.renderAccreditationsData()}
                </tbody>
            </Table>
        );
    };

    renderAccreditationsData() {
        return _.map(this.props.data, (accreditation, index) => (
            <tr key={accreditation.id} className="pending-accreditations-list-row">
                <td
                    className='pending-accreditation-title-original-td'
                    onClick={this.onShowAccreditationDetails(accreditation.id)}
                    data-th={_.get(this.props.translation, 'accreditation.accreditation_title_orig_label') + ":"}>
                    {accreditation.titleOriginal}
                </td>
                <td
                    className='pending-accreditation-title-en-td'
                    onClick={this.onShowAccreditationDetails(accreditation.id)}
                    data-th={_.get(this.props.translation, 'accreditation.accreditation_title_en_label') + ":"}>
                    {accreditation.titleEn}
                </td>
                <td
                    className='pending-accreditation-date-issued-td'
                    onClick={this.onShowAccreditationDetails(accreditation.id)}
                    data-th={_.get(this.props.translation, 'accreditation.date_issued_label') + ":"}>
                    {moment(accreditation.dateIssued).format("L")}
                </td>
                <td
                    className='pending-accreditation-issued-by-td'
                    onClick={this.onShowAccreditationDetails(accreditation.id)}
                    data-th={_.get(this.props.translation, 'applicant_accreditations_management.issued_by_label') + ":"}>
                    {accreditation.issuedByName + ', ' + _.get(this.props.translation, 'countries.' + accreditation.issuedByCountry)}
                </td>
                <td
                    className='pending-accreditation-level-td'
                    onClick={this.onShowAccreditationDetails(accreditation.id)}
                    data-th={_.get(this.props.translation, 'accreditation.level_label') + ":"}>
                    {_.get(this.props.translation, 'levels.' + accreditation.level)}
                </td>
                <td className='pending-accreditation-create-icon-td'
                    onClick={this.onShowAccreditationDetails(accreditation.id)}>
                    <IconContainer
                        icon='create'
                        key={index}
                        className='pending-accreditation-create-icon'
                        title={_.get(this.props.translation, 'accreditation_list.edit_label')}
                    />
                </td>
            </tr>
        ));
    }

    onShowAccreditationDetails = (id) => () => {
        this.setState({ currentAccreditationId: id });
    }
}

PendingAccreditationsList.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    onGetAccreditations: PropTypes.func.isRequired
};

export default PendingAccreditationsList;



// WEBPACK FOOTER //
// ./src/components/applicantAccreditationsManagement/pendingAccreditationsList/PendingAccreditationsList.js